import { Entity } from '@core/entities/entity/Entity'
import { IMFASession } from './IMFASession'
import { plainToInstance } from 'class-transformer'

export class MFASession extends Entity<IMFASession> {
  id: number
  description: string
  verifiedOn: string
  expiresOn: string
  isCurrentSession: boolean

  public static new(payload: unknown): MFASession {
    return plainToInstance(MFASession, payload)
  }

  public static formatDuration(seconds: number): string {
    const days = Math.floor(seconds / (24 * 60 * 60))
    const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60))
    const minutes = Math.floor((seconds % (60 * 60)) / 60)
    const secondsRemaining = seconds % 60

    const parts = []
    if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`)
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`)
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`)
    if (secondsRemaining > 0)
      parts.push(
        `${secondsRemaining} second${secondsRemaining !== 1 ? 's' : ''}`,
      )

    return parts.join(' ')
  }

  public static getVerifiedOnDate(verifiedOn: string): string {
    return new Date(verifiedOn).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }

  public static getExpiresOnDate(expiresOn: string): string {
    return new Date(expiresOn).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }

  public getDeviceType(): 'Mobile' | 'Desktop' | 'Unknown' {
    if (this.description.includes('Mobile')) {
      return 'Mobile'
    }

    if (this.description.includes('Desktop')) {
      return 'Desktop'
    }
  }
}
